import React, { useEffect, useState } from "react";
import { Typography, Button, DatePicker, Input, Table, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";

import Booking_Model from "src/components/Booking_Report/Booking_Model";
import CustomTableLoader from "src/components/common/CustomTableLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBooking,
  fetchCompany,
} from "src/redux/actions/bookingReportAction";
import Prepaid_Model from "src/components/Booking_Report/Prepaidmodel";
import { CSVLink } from "react-csv";

const { Title } = Typography;

interface BookingData {
  key: string;
  bookingId: string;
  name: string;
  mobileNo: string;
  cabId: string;
  distance: string;
  duration: string;
  fare: string;
  date: string;
  time: string;
  fromLoc: string;
  toLoc: string;
  vehicle: string;
  fareType: string;
  invoiceNo: string;
  customerId: string;
  goods: string;
  vehicleId: string;
}

const Booking_Report: React.FC = () => {
  const [selectedRowKey, setSelectedRowKey] = useState<React.Key | null>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const [searchText, setSearchText] = useState<string>("");
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [toDate, setToDate] = useState<Dayjs | null>(null);
  const [limit, setLimit] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreModalOpen, setPreModalOpen] = useState(false);

  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const cityid = userData.cityid;

  const dataSource = useSelector((state: any) => state.booking.data ?? []);
  const { totalFare, datacount } = useSelector((state: any) => state.booking);
  const update = useSelector((state: any) => state.booking.update);
  const loading = useSelector((state: any) => state.booking.loading);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    dispatch(fetchCompany(cityid));
    console.log(selectedRows);
  };

  const handlePrepaidModal = () => {
    setPreModalOpen(true);
    console.log(selectedRows);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRows([]);
    setSelectedRowKey("");
  };

  const handleClosePreModal = () => {
    setPreModalOpen(false);
    setSelectedRows([]);
    setSelectedRowKey("");
  };

  useEffect(() => {
    if (update?.success) {
      const from = dayjs();
      const to = dayjs();
      const toDatePlusOne = to.add(1, "day");
      setFromDate(from);
      setToDate(to);
      dispatch(
        fetchBooking(
          cityid,
          from.format("YYYY-MM-DD"),
          toDatePlusOne.format("YYYY-MM-DD"),
        ),
      );
    }
  }, [update.success]);

  const rowSelection = {
    type: "radio" as const,
    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKey(selectedRowKeys[0] || null);
      setSelectedRows(selectedRows);
    },
  };

  const columns: any = [
    {
      title: "Booking ID",
      dataIndex: "bookingid",
      key: "bookingid",
      align: "center",
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "center",
      fixed: "left",
    },
    {
      title: "Mobile No",
      dataIndex: "mobileNo",
      key: "mobileNo",
      align: "center",
      width: 110,
    },
    { title: "Cab ID", dataIndex: "cabId", key: "cabId", align: "center" },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      align: "center",
      width: 80,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      align: "center",
      width: 80,
    },
    {
      title: "Fare",
      dataIndex: "fare",
      key: "fare",
      align: "center",
      width: 80,
    },
    {
      title: "Date",
      dataIndex: "completedDate",
      key: "completedDate",
      align: "center",
      width: 110,
      render: (text: any) => text.split(",")[0],
    },
    {
      title: "Time",
      dataIndex: "completedDate",
      key: "Time",
      align: "center",
      width: 110,
      render: (text: any) => {
        const timePart = text.split(",")[1]?.trim();
        if (!timePart) return "";
        const [time, ampm] = timePart.split(" ");
        const [hours, minutes] = time.split(":");
        return `${hours}:${minutes} ${ampm?.toUpperCase()}`;
      },
    },
    {
      title: "From Location",
      dataIndex: "fromLoc",
      key: "fromLoc",
      align: "center",
    },
    { title: "To Location", dataIndex: "toLoc", key: "toLoc", align: "center" },
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "vehicle",
      align: "center",
      width: 110,
    },
    {
      title: "Fare Type",
      dataIndex: "fareType",
      key: "fareType",
      align: "center",
    },
    {
      title: "Invoice No",
      dataIndex: "invoiceno",
      key: "invoiceno",
      align: "center",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
      align: "center",
      width: 110,
    },
    { title: "Goods", dataIndex: "goods", key: "goods", align: "center" },
    {
      title: "Vehicle ID",
      dataIndex: "vehicleId",
      key: "vehicleId",
      align: "center",
    },
    {
      title: "Invoice",
      dataIndex: "Invoice",
      key: "Invoice",
      align: "center",
      width: 120,
      render: (_: any, record: any) => (
        <Button
          // style={{background:"#15955b"}}
          style={{
            background: record.invoiceno ? "#15955b" : "#d9d9d9",
            cursor: record.invoiceno ? "pointer" : "not-allowed",
          }}
          type="primary"
          size="small"
          icon={<DownloadOutlined />}
          disabled={!record.invoiceno}
          onClick={() => window.open(record.invoiceurl, "_blank")}
        />
      ),
    },
  ];

  useEffect(() => {
    const from = dayjs();
    const to = dayjs();

    const toDatePlusOne = to.add(1, "day");
    setFromDate(from);
    setToDate(to);

    dispatch(
      fetchBooking(
        cityid,
        from.format("YYYY-MM-DD"),
        toDatePlusOne.format("YYYY-MM-DD"),
      ),
    );
  }, []);

  const handleFetch = () => {
    if (fromDate && toDate) {
      const from = fromDate.format("YYYY-MM-DD");
      const toPlusOne = dayjs(toDate).add(1, "day").format("YYYY-MM-DD");

      dispatch(fetchBooking(cityid, from, toPlusOne));
    } else {
      message.warning("Please select both From and To dates.");
    }
  };

  const handleSearch = (value: string) => setSearchText(value || "");

  const filteredData = dataSource.filter((item: any) => {
    const matchesSearch = Object.values(item).some((field) =>
      String(field).toLowerCase().includes(searchText.toLowerCase()),
    );
    const itemDate = item.date ? dayjs(item.date) : null;
    const withinDateRange =
      (!fromDate ||
        (itemDate && itemDate.isAfter(fromDate.subtract(1, "day")))) &&
      (!toDate || (itemDate && itemDate.isBefore(toDate.add(1, "day"))));
    return matchesSearch && (itemDate ? withinDateRange : true);
  });

  const disableFutureDates = (current: any) => {
    return current && current > dayjs().endOf("day");
  };

  const disableToDate = (current: any) => {
    if (!fromDate) return disableFutureDates(current);
    return (
      (current && current < fromDate.startOf("day")) ||
      (current && current > dayjs().endOf("day"))
    );
  };
  return (
    <div
      style={{ minHeight: "100vh", overflow: "hidden", position: "relative" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          background: "whitesmoke",
          width: "100%",
        }}
      >
        <Title
          level={3}
          style={{
            fontSize: "35px",
            fontWeight: "bolder",
            color: "black",
            margin: 0,
          }}
        >
          Booking Report
        </Title>

        {/* Filters */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", gap: "10px", width: "50%" }}>
            {/* <DatePicker
              value={fromDate}
              onChange={(date) => setFromDate(date)}
              format="DD/MM/YYYY"
              placeholder="From Date"
            />
            <DatePicker
              value={toDate}
              onChange={(date) => setToDate(date)}
              format="DD/MM/YYYY"
              placeholder="To Date"
            /> */}
            <DatePicker
              value={fromDate}
              format="DD/MM/YYYY"
              onChange={(date) => {
                setFromDate(date);
                if (toDate && date && toDate.isBefore(date, "day")) {
                  setToDate(null);
                }
              }}
              disabledDate={disableFutureDates}
              style={{ border: "1px solid grey" }}
              placeholder="From Date"
            />

            <DatePicker
              value={toDate}
              format="DD/MM/YYYY"
              onChange={(date) => setToDate(date)}
              disabledDate={disableToDate}
              style={{ border: "1px solid grey" }}
              placeholder="To Date"
            />
            <Button
              onClick={handleFetch}
              style={{ color: "white", background: "#800080", fontWeight: 500 }}
            >
              Go
            </Button>
            <Button
              style={{ color: "white", background: "#0050b3" }}
              onClick={handleOpenModal}
              disabled={!selectedRows.length}
            >
              Corporate Bill
            </Button>
            <Button
              style={{ color: "white", background: "#0050b3" }}
              onClick={handlePrepaidModal}
              disabled={!selectedRows.length}
            >
              Prepaid
            </Button>
          </div>
          <div
            style={{
              width: "20%",
              gap: "2%",
              justifyContent: "space-between",
              display: "flex",
            }}
          >
            <Typography.Text strong style={{ fontSize: "20px" }}>
              Trips : {datacount || 0}
            </Typography.Text>
            <Typography.Text strong style={{ fontSize: "20px" }}>
              Fare : {totalFare || 0}
            </Typography.Text>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "end",
              width: "30%",
              alignItems: "center",
            }}
          >
            <CSVLink data={filteredData} filename="Booking-Report.csv">
              <Button
                icon={<DownloadOutlined />}
                style={{
                  background: "linear-gradient(45deg, #159957, #155799)",
                  color: "white",
                }}
                disabled={filteredData.length === 0}
              >
                Download
              </Button>
            </CSVLink>
            <Input.Search
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onSearch={handleSearch}
              style={{ width: "180px" }}
            />
          </div>
          {/* <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "end",
              width: "30%",
            }}
          >
            <Input.Search
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onSearch={handleSearch}
              style={{ width: "180px" }}
            />
          </div> */}
        </div>

        {/* Table */}
        <Table
          rowSelection={rowSelection}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          size="middle"
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 100,
          }}
          dataSource={filteredData}
          columns={columns}
          scroll={{ x: "calc(1700px + 50%)", y: 50 * 15 }}
          bordered
          rowKey="bookingid"
        />
      </div>

      {/* Modal */}
      <Booking_Model
        visible={isModalOpen}
        onClose={handleCloseModal}
        selectedRows={selectedRows}
        onSubmit={(data: {
          bookingId: string;
          cabId: string;
          company: string;
        }) => {
          message.info(`Submitted: ${JSON.stringify(data)}`);
        }}
      />
      <Prepaid_Model
        visible={isPreModalOpen}
        onClose={handleClosePreModal}
        selectedRows={selectedRows}
        onSubmit={(data: {
          bookingId: string;
          cabId: string;
          company: string;
        }) => {
          message.info(`Submitted: ${JSON.stringify(data)}`);
        }}
      />
    </div>
  );
};

export default Booking_Report;
